<template>
  <div class="container" :class="{vertical: isVertical, bottomFix: isBottomFix, downFix: isDownVertical, horizontalFix: isHorizontalVertical, HhorizontalFix: isHorizontalH}" :style="{'color':color, ...bgStyle}">
    <div class="leftArrow arrow" :class="{screenleftarrow:isScreenSize}"></div>
    <div class="middle" :class="{screensize:isScreenSize}" v-if="arrowWidth > 0"  :style="{'width': arrowWidth + 'px','background-color':color}"></div>
    <div class="rightArrow arrow" :class="{screenrightarrow:isScreenSize}" :style="{'left': arrowWidth + 'px'}"></div>
  </div>
</template>
<script>
import { mapState } from 'vuex'
export default {
  name: 'simpleArrrow',
  props: ['isVertical', 'isBottomFix', 'itemWidth', 'color', 'isDownVertical', 'isHorizontalVertical', 'isHorizontalH', 'isScreenSize', 'bgStyle'],
  data () {
    return {
      arrowOffset: 14,
      arrowFloorToBottomOffset: 12
    }
  },
  computed: {
    ...mapState(['selectedModelData']),
    arrowWidth () {
      if (this.isVertical) {
        return this.isVertical ? this.itemWidth - this.arrowOffset : this.itemWidth
      } else if (this.isBottomFix) {
        return this.isBottomFix ? this.itemWidth - this.arrowFloorToBottomOffset : this.itemWidth
      } else if (this.isDownVertical) {
        return this.isDownVertical ? this.itemWidth - this.arrowOffset : this.itemWidth
      } else if (this.isHorizontalVertical) {
        return this.isHorizontalVertical ? this.itemWidth - this.arrowOffset : this.itemWidth
      } else if (this.isHorizontalH) {
        return this.isHorizontalH ? this.itemWidth - this.arrowOffset : this.itemWidth
      }
    }
  }
}
</script>
<style scoped>
.container {
  position: relative;
}
.vertical {
  transform: rotate(90deg);
  transform-origin: left top;
  -ms-transform: rotate(90deg); /* Internet Explorer */
  -moz-transform: rotate(90deg); /* Firefox */
  -webkit-transform: rotate(90deg); /* Safari 和 Chrome */
  -o-transform: rotate(90deg);
}
.bottomFix {
  transform: rotate(-90deg);
  transform-origin: left bottom;
  -ms-transform: rotate(-90deg); /* Internet Explorer */
  -moz-transform: rotate(-90deg); /* Firefox */
  -webkit-transform: rotate(-90deg); /* Safari 和 Chrome */
  -o-transform: rotate(-90deg);
}
.downFix {
  transform: rotate(90deg);
  transform-origin: right bottom;
  -ms-transform: rotate(90deg); /* Internet Explorer */
  -moz-transform: rotate(90deg); /* Firefox */
  -webkit-transform: rotate(90deg); /* Safari 和 Chrome */
  -o-transform: rotate(90deg);
}
.horizontalFix {
  transform: rotate(0deg);
  transform-origin: right bottom;
  -ms-transform: rotate(0deg); /* Internet Explorer */
  -moz-transform: rotate(0deg); /* Firefox */
  -webkit-transform: rotate(0deg); /* Safari 和 Chrome */
  -o-transform: rotate(0deg);
}
.HhorizontalFix {
  transform: rotate(-180deg);
  -ms-transform: rotate(-180deg); /* Internet Explorer */
  -moz-transform: rotate(-180deg); /* Firefox */
  -webkit-transform: rotate(-180deg); /* Safari 和 Chrome */
  -o-transform: rotate(-180deg);
}
.arrow {
  position: relative;
}
.leftArrow {
  left: -12px;
  bottom: -8px;
  width: 0;
  height: 0;
  border-width: 6px;
  border-style: solid;
  border-color:transparent;
  border-right-color: inherit;
}
.rightArrow {
  bottom: 8px;
  width: 0;
  height: 0;
  border-width: 6px;
  border-style: solid;
  border-color:transparent;
  border-left-color: inherit;
}
.middle {
  height: 4px;
  position: relative;
}

.screensize {
  height: 2px;
}

.screenleftarrow {
  bottom: -7px;
}

.screenrightarrow {
  bottom: 7px;
}
</style>



// WEBPACK FOOTER //
// src/view/graph/Simple/simpleArrow.vue